import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { layout: 'auth', public: true, title: 'Sign in' },
  },
  {
    path: '/',
    component: () => import('@/layouts/AppLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/dashboard',
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/DashboardView.vue'),
        meta: { title: 'Dashboard' },
      },
      {
        path: 'transactions',
        name: 'transactions',
        component: () => import('@/views/TransactionsView.vue'),
        meta: { title: 'Transactions' },
      },
      {
        path: 'transfer/bank',
        name: 'transfer-bank',
        component: () => import('@/views/TransferView.vue'),
        meta: { title: 'Bank to Bank Transfer' },
      },
      {
        path: 'transfer/nonbank',
        name: 'transfer-nonbank',
        component: () => import('@/views/NonBankTransferView.vue'),
        meta: { title: 'Bank to Non-Bank Transfer' },
      },
      {
        path: 'transfer/confirm',
        name: 'transfer-confirm',
        component: () => import('@/views/CotView.vue'),
        meta: { title: 'Confirm Transfer' },
      },
      {
        path: 'statement',
        name: 'statement',
        component: () => import('@/views/StatementView.vue'),
        meta: { title: 'Statement' },
      },
      {
        path: 'messages',
        name: 'messages',
        component: () => import('@/views/MessagesView.vue'),
        meta: { title: 'Messages' },
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/views/SettingsView.vue'),
        meta: { title: 'Settings' },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { public: true, title: 'Not found' },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_PUBLIC_BASE || '/'),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  await auth.restoreSession()

  const isPublic = to.meta.public === true
  if (!isPublic && !auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'dashboard' }
  }
})

router.afterEach((to) => {
  const title = (to.meta.title as string) || 'Internet Banking'
  document.title = `${title} - City Union Trust`
})

export default router
